import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Lenis from "@studio-freight/lenis";
import { useAuth } from "@/contexts/TradeAuthContext";
import TradeNav from "@/pages/trade/TradeNav";
import "@/trade.css";

const TradeLayout = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => lenis.destroy();
  }, []);

  if (!isAuthenticated) {
    return <Navigate to="/trade/login" state={{ from: location }} replace />;
  }

  return (
    <>
      <TradeNav />
      <Outlet />
    </>
  );
};

export default TradeLayout;
